<div class="col_12" id="composition-item">

    <div class="row marges content-col-date">

        <!-- Participants -->

        <div class="col_12 col_lg_6 semi-col-date" id="composition-step-traveller">

            <div class="item_date composition-data-wrapper" [ngClass]="getConfigurationStepDataElementClasses(configurationSteps.traveller)">

                <div class="composition-step-label" [ngClass]="getConfigurationStepLabelClasses(configurationSteps.traveller)">
                    {{ 'offer.dateEngine.traveller.plural.value' | translate }}
                </div>

                <div class="composition-step-content">

                    <div class="row">

                        <!-- Adulte -->

                        @if(offer.publics.includes('adult')) {

                            <div class="choice_item choice_people y_items_center" [ngClass]="{'col_6' : offer.publics.includes('child'), 'col_12': !offer.publics.includes('child')}">
                                <div class="content_item">

                                    <select [(ngModel)]="countAdult" (change)="countAdultUpdatedSubject.next()">
                                        @for(count of countAdultValues; track count) {
                                            <option [ngValue]="count">{{ count }}</option>
                                        }
                                    </select>

                                    <span class="label">{{ 'offer.dateEngine.adult.count.value' | translate }}</span>

                                </div>

                            </div>
                        }

                        <!-- Enfant -->

                        @if(offer.publics.includes('child')) {

                            <div class="choice_item choice_people y_items_center" [ngClass]="{'col_6' : offer.publics.includes('adult'), 'col_12': !offer.publics.includes('adult')}">
                                <div class="content_item">

                                    <select [(ngModel)]="countChild" (change)="countChildUpdatedSubject.next()">
                                        @for(count of countChildValues; track count) {
                                            <option [ngValue]="count">{{ count }}</option>
                                        }
                                    </select>

                                    <span class="label">{{ 'offer.dateEngine.child.count.value' | translate }}</span>

                                </div>
                            </div>
                        }

                    </div>

                </div>

                @if(!isValidNbPerson) {
                    <mat-error>
                        <div class="invalid-feedback">
                            <div>{{ 'form.control.error.nbPerson.max_exceed.value' | translate: {max: (offer.presential.max)} }}</div>
                        </div>
                    </mat-error>
                }

                @if(offer.publics.includes('child')) {
                    <p class="info_step icon_info">
                        {{ 'offer.booking.composition.child.age.interval.value'|translate:{minChildrenAge: (offer.minChildrenAge), maxChildrenAge: (offer.maxChildrenAge|formatAge)} }}
                    </p>
                }

            </div>

        </div>

        <!-- Dates -->

        <div class="col_12 col_lg_6 semi-col-date" id="composition-step-date">

            <div class="item_date composition-data-wrapper" [ngClass]="getConfigurationStepDataElementClasses(configurationSteps.date)">

                <div class="col_12 composition-step-label" [ngClass]="getConfigurationStepLabelClasses(configurationSteps.date)">
                    {{ 'offer.dateEngine.date.plural.value' | translate }}
                </div>

                <div class="composition-step-content">

                    <div class="row">

                        <div class="col content_items">

                            <div class="row">

                                <!-- Départ -->

                                <div (click)="toggleCalendar()" class="col_6 choice_item choice_date y_items_center is_clickable" [ngClass]="{'open' : isCalendarOpened}">
                                    <div class="content_item">
                                        <span class="label">{{ 'arrival.value' | translate }}</span>

                                        @if(!displayedDates.start) {
                                            <span class="value">{{ 'date.add.action.value' | translate }}</span>
                                        } @else {
                                            <span class="value">{{ displayedDates.start.format('L') }}</span>
                                        }
                                    </div>
                                </div>

                                <!-- Retour -->

                                <div class="col_6 choice_item choice_date y_items_center disabled">
                                    <div class="content_item">
                                        <span class="label">{{ 'departure.value' | translate }}</span>

                                        @if(!!displayedDates.end) {
                                            <span class="value">{{ displayedDates.end.format('L') }}</span>
                                        }
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>

                </div>

                @if(configurationSteps.date.enabled && !isValidationDateSelectionValid) {
                    <p class="info_step error hidden">{{ 'offer.dateEngine.choicedate.error.value' | translate }}</p>
                }

                <!-- Affichage du calendrier -->

                <div [hidden]="!isCalendarOpened" class="offer_calendar">

                    <div>

                        <div class="navigation">

                            <!-- Semaine précédante -->

                            <div class="btn_cta btn_small btn_lines prev" [ngClass]="{ disabled: !isNavigationToPreviousMonthAllowed }" (click)="navigateToPreviousMonth()">
                                <mat-icon>chevron_left</mat-icon>
                            </div>

                            <!-- Semaine suivante -->

                            <div class="btn_cta btn_small btn_lines next" (click)="navigateToNextMonth()">
                                <mat-icon>chevron_right</mat-icon>
                            </div>

                        </div>

                        <!-- Affichage des mois -->

                        <div class="row x_between">
                            @for(month of months; track month) {
                                <div class="month">

                                    <div class="month_label">
                                        <span>{{ month.label }}</span>
                                    </div>

                                    <!-- Affichage des jours de la semaine (Lundi, Mardi...) -->

                                    <div class="row">
                                        @for(dayName of dayNames; track dayName) {
                                            <div class="day day_name">
                                                {{ dayName }}
                                            </div>
                                        }
                                    </div>

                                    <div class="row">

                                        <!-- Affichage des jours du mois précédant -->

                                        @for(day of month.previousMonthDays; track day) {

                                            <div class="day">

                                                <!-- Le jour appartenant au mois précédant, celui-ci n'est pas affiché -->

                                            </div>
                                        }

                                        <!-- Affichage des jours du mois courant -->

                                        @for(day of month.days; track day) {

                                            <div [ngClass]="getDayClasses(day, availabilities[day.format('YYYY-MM-DD')])" (click)="updateSelection(day, availabilities[day.format('YYYY-MM-DD')])" class="day">

                                                <div class="legend-icon" [ngClass]="getDayPastilleClasses(availabilities[day.format('YYYY-MM-DD')])"></div>

                                                <span class="day_number">
                                            {{ day.format('DD') }}
                                        </span>

                                                @if(configuration.displayDayDetails) {

                                                    @if(availabilities[day.format('YYYY-MM-DD')].isAvailable) {

                                                        @if(availabilities[day.format('YYYY-MM-DD')].promotionPrice > 0) {
                                                            <span class="day_info"><span [ngClass]="availabilities[day.format('YYYY-MM-DD')].promotionPrice < availabilities[day.format('YYYY-MM-DD')].price ? 'promotion' : ''">{{ availabilities[day.format('YYYY-MM-DD')].promotionPrice | parsePrice }} {{ availabilities[day.format('YYYY-MM-DD')].currency.symbol }} {{ availabilities[day.format('YYYY-MM-DD')].priceTypeLabel | translate }}</span></span>
                                                        }
                                                    }

                                                    @if(availabilities[day.format('YYYY-MM-DD')].isOnRequest) {
                                                        <span class="day_info">{{ 'offer.availability.onRequest.value' | translate }}</span>
                                                    }
                                                }

                                            </div>
                                        }

                                    </div>
                                </div>
                            }
                        </div>

                        <!-- Prix Net / Public -->

                        @if(configuration.displayPriceType) {

                            <div class="row marges">

                                <div class="col_12 choice_price">
                                    <div class="form-group">
                                        <mat-radio-group [(ngModel)]="publicPrice" [disabled]="!configuration.enablePriceTypeUpdate" (ngModelChange)="pricePublicUpdatedSubject.next()">
                                            <mat-radio-button [value]="0">{{ 'offer.dateEngine.publicPrice.net.value' | translate }}</mat-radio-button>
                                            <mat-radio-button [value]="1">{{ 'offer.dateEngine.publicPrice.public.value' | translate }}</mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                </div>
                            </div>
                        }

                        <div class="row x_between y_items_center">

                            <!-- Légende du calendrier -->

                            <div class="row marges legends">

                                <div class="col_content">
                                    <div class="legend">
                                        <span class="legend-icon legend-available"></span>
                                        <span>{{ 'offer.dateEngine.calendar.availability.available.value' | translate }}</span>
                                    </div>
                                </div>

                                <div class="col_content">
                                    <div class="legend">
                                        <span class="legend-icon legend-onbooking"></span>
                                        <span>{{ 'offer.dateEngine.calendar.availability.onBooking.value' | translate }}</span>
                                    </div>
                                </div>

                                <div class="col_content">
                                    <div class="legend">
                                        <span class="legend-icon legend-onrequest"></span>
                                        <span>{{ 'offer.dateEngine.calendar.availability.onRequest.value' | translate }}</span>
                                    </div>
                                </div>

                            </div>

                            <!-- Actions -->

                            <div class="row marges x_end">

                                <div class="col_content y_items_center buttons">

                                    <!-- Fermeture du calendrier -->

                                    <button type="button" class="btn_cta btn_little btn_lines" (click)="closeCalendar()">{{ 'notification.close.action.value' | translate }}</button>

                                    <!-- Validation de la sélection -->

                                    @if(configuration.enableSelectionValidation) {
                                        <button type="button" class="btn_cta btn_little" [disabled]="!isValidationDateSelectionValid" (click)="validateSelection('date')">{{ 'offer.dateEngine.selection.validate.action.value' | translate }}</button>
                                    }

                                    <!-- Ajout automatique au catalogue avant validation de la sélection -->

                                    @if(configuration.enableAutoAddInCatalog) {
                                        <button type="button" class="btn_cta btn_little" [disabled]="!isValidationDateSelectionValid || !userService.hasAccess(user, 'OFFER_CATALOG_CREATE') || !configuration.isValidCatalogStatus" (click)="validateSelection('catalog')" matTooltip="{{ `offer.dateEngine.selection.validate.${!userService.hasAccess(user, 'OFFER_CATALOG_CREATE') ? 'disabled' : (!configuration.isValidCatalogStatus ? 'request_refused' : '')}.value` | translate }}" matTooltipPosition="above" [matTooltipDisabled]="userService.hasAccess(user, 'OFFER_CATALOG_CREATE') && configuration.isValidCatalogStatus">{{ 'offer.dateEngine.selection.validate.action.value' | translate }}</button>
                                    }

                                </div>
                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>

    <div class="row marges">

        <ng-container *ngTemplateOutlet="childInformations"></ng-container>

    </div>

    @if(configurationSteps.traveller.enabled) {

        <!-- Valider -->
        <div class="row marges">

            <div class="col_12 col_lg_6 semi-col-date x_end">
                <button type="button" class="btn_cta btn_lines btn_small" (click)="validateTravellerStep()">
                    {{ 'offer.dateEngine.step.validate.value' | translate }}
                </button>
            </div>

        </div>

    } @else {

        <!-- Modifier -->

        <div class="row marges">
            <div class="col_12 col_lg_6 semi-col-date x_end">
                <button type="button" class="btn_cta btn_lines btn_small" (click)="updateTravellerStep()">
                    {{ 'offer.dateEngine.step.update.value' | translate }}
                </button>
            </div>
        </div>
    }

</div>

<ng-template #childInformations>

    <div class="col_12 col_lg_6 semi-col-date" id="child-informations-container">

        @if((offer.customerTypology.type === 'I') && (countChild > 0)) {

            <div class="item_date composition-data-wrapper" [ngClass]="getConfigurationStepDataElementClasses(configurationSteps.traveller)">

                <div class="composition-step-content">

                    <form [formGroup]="form" class="row">

                        @for (_ of participantsControls.controls; let i = $index; track i) {
                            <div class="choice_item choice_people choice_children col_12 col_lg_6 y_items_start" formArrayName="participants">

                            <ng-container [formGroupName]="indexAsString(i)">

                                <div class="content_item form-group">

                                    <input type="text" class="datetimepicker" matInput readonly [matDatepicker]="birthDatePicker" formControlName="birthDay" (click)="birthDatePicker.open()" id="birthDay-{{i}}" placeholder="Ajouter une date">

                                    <span class="label">{{ 'offer.form.fields.birthdate.value' | translate }} {{ 'offer.form.fields.child.value' | translate: {count: i + 1} }}
                                        :</span>

                                    <mat-datepicker #birthDatePicker></mat-datepicker>

                                    @if(displayChildInformationsValidators && participantsControl(i).get('birthDay').errors && (participantsControl(i).get('birthDay').dirty|| participantsControl(i).get('birthDay').touched)) {
                                        <mat-error>

                                            <div class="invalid-feedback">
                                                @if(participantsControl(i).get('birthDay').errors.required) {
                                                    <div>{{ 'form.control.error.birthdate.required.value' | translate }}</div>
                                                }
                                                @if(participantsControl(i).get('birthDay').errors.birthdateInvalid) {
                                                    <div>{{ 'form.control.error.birthdate.invalid.value' | translate }}</div>
                                                }
                                            </div>

                                        </mat-error>
                                    }

                                </div>

                            </ng-container>

                        </div>
                        }

                    </form>

                </div>

            </div>
        }

    </div>

</ng-template>
